import { toastFailed, toastSuccess } from 'utils/toast'
import {
  SET_IS_SUCCESS_CAMPAIGN_ADD,
  SET_PAGINATION_DATA_CAMPAIGN_ADD,
  SET_IS_NEED_TO_RELOAD_CAMPAIGN_ADD,
  SET_IS_DETAIL_DATA_CAMPAIGN_ADD,
  RESET_CAMPAIGN,
} from 'storeContext/actionsType/campaign'
import {
  getCampaign_CAMPAIGN_ADD,
  putUpdateDataCampaign_CAMPAIGN_ADD,
  postCreateCampaign_CAMPAIGN_ADD,
  postBulkUploadCampaign_CAMPAIGN_ADD,
  putEditAllCampaign_CAMPAIGN_ADD,
  deleteRemoveInventoriesCampaign_CAMPAIGN_ADD,
  getBulkUploadInventoriesCampaign_CAMPAIGN_ADD,
} from 'utils/apiList/campaign'
import { callErrorMsg } from 'helpers/errorMsg'
import {
  GetInventoryListByIdRequestType,
  getInventoryListById,
  PutInventoryDiscountByIdRequestType,
  putInventoryDiscountById,
} from 'features/CampaignAndDiscount/services/campaignAddEdit'
import { campaignStart, campaignStop } from './index'

/* eslint-disable @typescript-eslint/naming-convention, arrow-body-style -- Legacy exported names and return blocks are consumed across the app. */

type CampaignAddDispatchType = (action: unknown) => void
type CampaignAddGetStateType = () => unknown
type CampaignAddMutationErrorType = {
  status?: boolean
  message?: string
  code?: string | number
}
type CampaignAddMutationResponseType = {
  error?: CampaignAddMutationErrorType
  data?: { id?: string | number }
}
type CampaignAddErrorType = {
  response?: { data: CampaignAddMutationResponseType }
}
type CampaignAddInventoryPaginationResponseType = {
  number_of_elements?: number
  page_index?: number
  page_size?: number
  total_elements?: number
  total_pages?: number
}
type CampaignAddInventoryTierType = {
  discounted_price: number
  discount_percentage: number
  threshold: number
}
type CampaignAddInventoryPriceDetailType = {
  campaign_inventory_id: number
  astro_percentage: number
  daily_quota: number
  discount_percentage: number
  discount_quota: number
  discounted_price: number
  global_daily_quota: unknown
  segment_data: { segment_id: number; segment_name: string }
  user_segment: string
  tier: CampaignAddInventoryTierType[] | null
  [key: string]: unknown
}
type CampaignAddInventoryItemType = {
  campaign_price_details: CampaignAddInventoryPriceDetailType[]
  original_price: number
  product_name: string
  location_id: number
  product_stock: number
  product_id: number
  location_name: string
  product_sku_number: string
  astro_percentage: number
  is_flash_sale: boolean
  [key: string]: unknown
}
type CampaignAddInventoryResponseType = {
  error?: CampaignAddMutationErrorType
  data: {
    content: CampaignAddInventoryItemType[]
    pagination?: CampaignAddInventoryPaginationResponseType
  }
}
type CampaignAddInventoryLocalStateType = {
  search: {
    pageIndex?: number
    pageSize?: number
    categorySelected?: unknown[]
    location?: Record<string, unknown>
    name?: string
    [key: string]: unknown
  }
  getInventoryProductList?: (arg: { value: unknown[] }) => void
}
type CampaignAddDetailLocalStateType = {
  query: string
  getCampaignDetail?: (data: Record<string, unknown>) => void
}
type CampaignAddDetailResponseType = {
  error: CampaignAddMutationErrorType
  data: Record<string, unknown> & { campaign_type?: string }
}
type CampaignAddMutationLocalStateType = {
  dataToSend: unknown
}
type CampaignAddDeleteLocalStateType = {
  dataToSend: unknown
  handleClickClose?: () => void
}
type CampaignAddCreateLocalStateType = {
  dataToSend: unknown
  history?: { replace: (location: { search: string }) => void }
  getParams?: (key: string) => string | null
}
type CampaignAddUploadLocalStateType = {
  dataToSend: { file: File }
  setFileCSV?: (updater: (prev: Record<string, unknown>) => Record<string, unknown>) => void
  upStatus: { ON_CHOOSE_FILE: string }
}
type CampaignAddUploadComponentStateType = {
  setProgress?: (progress: string) => void
}
type CampaignAddTemplateLocalStateType = {
  params: unknown
  setUrlTemplate?: (url: string) => void
}
type CampaignAddEditItemLocalStateType = {
  dataToSend: PutInventoryDiscountByIdRequestType['payload']
}

export const setData_CampaignAdd = (data: unknown) => {
  return {
    type: SET_IS_SUCCESS_CAMPAIGN_ADD,
    payload: data,
  }
}

export const setPaginationData_CampaignAdd = (data: unknown) => {
  return {
    type: SET_PAGINATION_DATA_CAMPAIGN_ADD,
    payload: data,
  }
}

export const needToRelaod_CampaignAdd = () => {
  return {
    type: SET_IS_NEED_TO_RELOAD_CAMPAIGN_ADD,
  }
}

export const setDetailData_CampaignAdd = (data: unknown) => {
  return {
    type: SET_IS_DETAIL_DATA_CAMPAIGN_ADD,
    payload: data,
  }
}

export const resetState = (_data?: unknown) => {
  return {
    type: RESET_CAMPAIGN,
  }
}

export const getListOfCampaignInventory_CAMPAIGN_ADD =
  (campaign_id: string | number | null, localState: CampaignAddInventoryLocalStateType) =>
  (dispatch: CampaignAddDispatchType) => {
    const { search } = localState

    const params: Record<string, unknown> = {
      page_index: search.pageIndex,
      page_size: search.pageSize,
    }

    if (search.categorySelected) {
      params.categoryId = search.categorySelected.toString()
    }

    if (search.location?.location_id) {
      params.location_ids = search.location.location_id
    }

    if (search.name) {
      params.name = search.name
    }

    return getInventoryListById({
      id: campaign_id as unknown as string,
      params: params as unknown as GetInventoryListByIdRequestType['params'],
    })
      .then((response) => {
        const data = response.data as unknown as CampaignAddInventoryResponseType
        if (!!data?.error?.status === false) {
          const { content, pagination: resPagination } = data.data

          const pagination = {
            currentItem: resPagination?.number_of_elements,
            currentPage: resPagination?.page_index,
            pageSize: resPagination?.page_size,
            totalData: resPagination?.total_elements,
            totalPage: resPagination?.total_pages,
          }

          const modifiedContent = content.map((el) => {
            const campaignPriceDetails = el.campaign_price_details.map((ell) => {
              return {
                // ...ell,
                campaignInventoryId: ell.campaign_inventory_id,
                astroPercentage: ell.astro_percentage,
                dailyQuota: ell.daily_quota,
                discountPercentage: ell.discount_percentage,
                discountQuota: ell.discount_quota,
                discountedPrice: ell.discounted_price,
                uniqueId: window.crypto.randomUUID(),
                isShowRow: true,
                globalDailyQuota: ell.global_daily_quota,
                segmentData: {
                  segmentId: ell.segment_data.segment_id,
                  segmentName: ell.segment_data.segment_name,
                },
                userSegment: ell.user_segment,
                segment_data: ell?.segment_data,
                tier: !ell?.tier
                  ? null
                  : ell?.tier?.map((elTier) => {
                      return {
                        discountedPrice: elTier.discounted_price,
                        discountPercentage: elTier.discount_percentage,
                        threshold: elTier.threshold,
                        uniqueId: window.crypto.randomUUID(),
                      }
                    }),
              }
            })

            return {
              locationId: el.location_id,
              locationName: el.location_name,
              astroPercentage: el.astro_percentage,
              originalPrice: el.original_price,
              productId: el.product_id,
              productName: el.product_name,
              productSkuNumber: el.product_sku_number,
              productStock: el.product_stock,
              uniqueId: window.crypto.randomUUID(),
              isShowRow: true,
              isFlashSale: el.is_flash_sale,
              campaignPriceDetails,
            }
          })

          localState.getInventoryProductList!({ value: modifiedContent })
          dispatch(setData_CampaignAdd(modifiedContent))
          dispatch(setPaginationData_CampaignAdd(pagination))
        } else {
          toastFailed(data.error!.message)
        }
      })
      .catch(() => {
        toastFailed(`terjadi kesalahan, coba beberapa saat lagi`)
      })
  }

export const getListOfCampaignAdd =
  (campaign_id: string | number | null, localState: CampaignAddDetailLocalStateType) =>
  (dispatch: CampaignAddDispatchType, _getState: CampaignAddGetStateType) => {
    const { query } = localState
    dispatch(campaignStart())

    return getCampaign_CAMPAIGN_ADD(campaign_id, query)
      .then(({ data }: { data: CampaignAddDetailResponseType }) => {
        if (data.error.status === false) {
          localState.getCampaignDetail!({ ...data.data, campaignType: data.data.campaign_type })

          // dispatch()
          dispatch(setDetailData_CampaignAdd(data.data))
        } else {
          toastFailed(data.error!.message)
        }

        dispatch(campaignStop())
      })
      .catch(() => {
        toastFailed(`terjadi kesalahan, coba beberapa saat lagi`)
        dispatch(campaignStop())
      })
  }

export const updateCampaignData_CAMPAIGN_ADD =
  (campaign_id: string | number | null, localState: CampaignAddMutationLocalStateType) =>
  (dispatch: CampaignAddDispatchType) => {
    dispatch(campaignStart())
    const { dataToSend } = localState

    // @ts-expect-error -- Legacy call omits the axios config argument.
    return putUpdateDataCampaign_CAMPAIGN_ADD(campaign_id, dataToSend)
      .then(({ data }: { data: CampaignAddMutationResponseType }) => {
        if (!!data?.error?.status === false) {
          toastSuccess('Campaign Berhasil dirubah')

          dispatch(needToRelaod_CampaignAdd())
        } else {
          toastFailed(data.error!.message)
        }
        dispatch(campaignStop())
      })
      .catch((err: CampaignAddErrorType) => {
        const { data } = err.response!

        if (data.error!.status) {
          toastFailed(` ${data.error!.message}, code : ${data.error!.code} `)
        } else {
          toastFailed(`terjadi kesalahan, coba beberapa saat lagi`)
        }

        dispatch(campaignStop())
      })
  }

export const createNewCampaign_CAMPAIGN_ADD =
  (localState: CampaignAddCreateLocalStateType) => (dispatch: CampaignAddDispatchType) => {
    dispatch(campaignStart())
    const { dataToSend, history, getParams } = localState

    return postCreateCampaign_CAMPAIGN_ADD(dataToSend)
      .then(({ data }: { data: CampaignAddMutationResponseType }) => {
        if (data?.error?.message) {
          toastFailed(` ${data.error!.message} `)
        } else {
          history!.replace({
            search: `?campaignId=${data.data!.id}&type=${getParams!('type')}`,
          })
          toastSuccess('Campaign Berhasil dibuat')
        }
        dispatch(campaignStop())
      })
      .catch((err: CampaignAddErrorType) => {
        if (err?.response?.data) {
          const { data } = err.response

          if (data.error!.status) {
            toastFailed(` ${data.error!.message} `)
          } else {
            toastFailed(`terjadi kesalahan, coba beberapa saat lagi`)
          }
        }
        dispatch(campaignStop())
      })
  }

export const deleteCampaingSingleandAll_CAMPAIGN_ADD =
  (campaign_id: string | number | null, localState: CampaignAddDeleteLocalStateType) =>
  (dispatch: CampaignAddDispatchType) => {
    return deleteRemoveInventoriesCampaign_CAMPAIGN_ADD(campaign_id, localState.dataToSend)
      .then(() => {
        toastSuccess('Campaign Berhasil Di delete')
        dispatch(needToRelaod_CampaignAdd())
        dispatch(campaignStop())
        localState.handleClickClose!()
      })
      .catch(() => {
        // const { error } = err.response.data;
        toastFailed(`terjadi kesalahan, coba beberapa saat lagi`)
        // toastFailed(`code : ${error.code} , ${error.message}`);
        dispatch(campaignStop())
      })
  }

export const editAllCampaign_CAMPAIGN_ADD =
  (campaign_id: string | number | null, localState: CampaignAddDeleteLocalStateType) =>
  (dispatch: CampaignAddDispatchType) => {
    // @ts-expect-error -- Legacy route id can be a string or null at this boundary.
    return putEditAllCampaign_CAMPAIGN_ADD(campaign_id, localState.dataToSend)
      .then(() => {
        toastSuccess('Semua Diskon Berhasil Di update')
        dispatch(needToRelaod_CampaignAdd())
        localState.handleClickClose!()
        dispatch(campaignStop())
      })
      .catch(() => {
        toastFailed(`terjadi kesalahan, coba beberapa saat lagi`)
        dispatch(campaignStop())
      })
  }

export const uploadByBulkCampaign_CAMPAIGN_ADD =
  (
    campaign_id: string | number | null,
    localState: CampaignAddUploadLocalStateType,
    componentState: CampaignAddUploadComponentStateType,
  ) =>
  async (_dispatch: CampaignAddDispatchType) => {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }

    try {
      await postBulkUploadCampaign_CAMPAIGN_ADD(campaign_id, localState.dataToSend.file, config)
      componentState.setProgress!('Uploading ...')
    } catch (error) {
      localState.setFileCSV!((prev) => {
        return {
          ...prev,
          status: localState.upStatus.ON_CHOOSE_FILE,
        }
      })
      toastFailed('terjadi masalah, coba beberapa saat lagi')
    }
  }

export const getTemplateOfBulkUploadCampaignInventories_CAMPAIGN_ADD =
  (localState: CampaignAddTemplateLocalStateType) => (_dispatch: CampaignAddDispatchType) => {
    return getBulkUploadInventoriesCampaign_CAMPAIGN_ADD({ params: localState.params })
      .then(({ data }: { data: { data: { url: string } } }) => {
        localState.setUrlTemplate!(data.data.url)
      })
      .catch(() => {
        toastFailed('gagal mendapatkan template, coba beberapa saat lagi')
      })
  }

export const editCampaignInventoryByItem_CAMPAIGN_ADD =
  (campaign_inventory_id: string | number | null, localState: CampaignAddEditItemLocalStateType) =>
  (dispatch: CampaignAddDispatchType) => {
    dispatch(campaignStart())

    return putInventoryDiscountById({
      id: campaign_inventory_id as unknown as string,
      payload: localState.dataToSend,
    })
      .then((response) => {
        const data = response.data as CampaignAddMutationResponseType
        if (data?.error?.message) {
          toastFailed(data?.error?.message)
        } else {
          dispatch(needToRelaod_CampaignAdd())
        }
        dispatch(campaignStop())
      })
      .catch((err: unknown) => {
        callErrorMsg(err)
        dispatch(campaignStop())
      })
  }
